import { apiSlice } from '@services/apiSlice';
import { ContactUs as endpoints } from '@services/endpoints';
import { SerialLinkData, Enquiry } from './EnquiryForm.types';

export interface SubmitFormResponse {
  success: boolean;
  message: string;
}

const enquiryApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchSerialLinkData: build.query<
      SerialLinkData,
      {
        pageId?: string;
      }
    >({
      query: (params) => ({
        url: endpoints.fetchEnquirySerialLinkData,
        params: {
          language: window.lang,
          pageId: params.pageId ?? window.pageId,
        },
      }),
    }),
    fetchEnquiryForm: build.query<
      Enquiry,
      {
        pageId?: string;
        enquiryType: string;
        categoryId?: string;
      }
    >({
      query: (params) => {
        const searchParams = new URLSearchParams(window.location.search);
        const hasProductData = !!history.state?.product;
        return {
          url: endpoints.fetchEnquiryForm,
          params: {
            language: window.lang,
            pageId: params.pageId ?? window.pageId,
            enquiryType: params.enquiryType,
            countryId: window.countryId,
            CategoryID: params.categoryId || localStorage.getItem('CategoryID') || null,
            productLineId: hasProductData ? '' : searchParams.get('productLine') || '',
            productModelId: hasProductData ? '' : searchParams.get('productModel') || '',
            productLinePageId: hasProductData ? '' : searchParams.get('productLinePageId') || '',
          },
        };
      },
      transformResponse: (response: Enquiry) => {
        const hasProductData = !!history.state?.product;
        const productData = history.state?.product;

        const productSection = hasProductData
          ? [
              {
                SubHeading: response.Page.ProductSelectedTitle,
                FormField: [
                  {
                    DataType: 'QuoteItem',
                    Name: productData.name,
                    ProductDescription: productData.description,
                    ImageSrc: productData.imageSrc,
                  },
                ],
              },
            ]
          : [];
        return {
          ...response,
          FormData: {
            ...response.FormData,
            FormSections: [...productSection, ...response.FormData.FormSections],
          },
        };
      },
    }),
    fetchEnquiryApplicationList: build.query<{ ApplicationJsonList: string }, number>({
      query: (industryId) => ({
        url: endpoints.fetchEnquiryApplicationList,
        params: {
          lang: window.lang,
          ID: industryId,
        },
      }),
    }),
    submitEnquiryForm: build.mutation<SubmitFormResponse, FormData>({
      query: (data) => ({
        url: endpoints.submitEnquiryForm,
        method: 'POST',
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchSerialLinkDataQuery,
  useLazyFetchEnquiryFormQuery,
  useFetchEnquiryApplicationListQuery,
  useSubmitEnquiryFormMutation,
} = enquiryApi;
